import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { SkyLightStateless } from 'react-skylight';
import ContentWrapper from '../Layout/ContentWrapper';

const styles = {
  marginLeft: '10%',
  marginRight: '10%',
  textAlign: 'center',
  fontSize: '25px',
};

const buttonWrapperStyle = {
  display: 'flex',
  textAlign: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: '0px',
}

const notifyModalStyle = {
  width: '400px',
  height: '250px',
  marginLeft: '-15%',
};

const Modal = ({ content, onConfirm, onCancel }) => (
  <ContentWrapper>
    <Row>
      <Col xs={12} style={{ padding: '20px' }}>
        <div style={styles}>
          {
            content
          }
        </div>
      </Col>
    </Row>
    <Row>
      {/* <Col xs={6} style={buttonWrapperStyle}>
        <button
          className="btn btn-primary col-sm-6 buttonStyle"
          onClick={onCancel}
        >
          <Translate value="edit" />
        </button>
      </Col> */}
      <Col xs={12} style={buttonWrapperStyle}>
        <button
          className="btn btn-primary col-sm-6 buttonStyle"
          onClick={onConfirm}
        >
          <Translate value="confirm" />
        </button>
      </Col>
    </Row>
  </ContentWrapper>);

const NotifyModal = ({
  title, content, onConfirm, onCancel, isVisible
}) => (
    <SkyLightStateless
      dialogStyles={notifyModalStyle}
      isVisible={isVisible}
      onCloseClicked={onCancel}
      title={title}
    >
      <Modal
        content={content}
        onConfirm={onConfirm}
        onCancel={onCancel}
      />
    </SkyLightStateless>);

export default NotifyModal;



// WEBPACK FOOTER //
// ./master/jsx/components/common/notifyModal.jsx